import { getArgsAsTypesafeObjectProperties } from '../constants-util';

export const constants = getArgsAsTypesafeObjectProperties(
	'GET_UNIT_SERVICE_HISTORIES',
	'GET_LATEST_UNIT_SERVICE_HISTORIES',
	'CREATE_UNIT_SERVICE_HISTORY',
);
